import Image from "next/image"

import { TimesIcon } from "@/features/checkout/redesign/Icons"

export interface PartnerLogo {
  src: string
  alt: string
}

interface PartnerLockupProps {
  partnerLogo: PartnerLogo
  className?: string
}

export const PartnerLockup = ({ partnerLogo, className = "" }: PartnerLockupProps) => (
  <div data-testid="partner-banner" className={`flex h-[27px] min-w-0 items-center gap-200 ${className}`}>
    <Image src="/images/nelo_logo_web.svg" alt="Nelo" width={51} height={22} className="shrink-0 self-start" />
    <TimesIcon className="text-fg shrink-0" />
    <img src={partnerLogo.src} alt={partnerLogo.alt} decoding="async" className="h-auto max-h-[27px] w-auto min-w-0" />
  </div>
)
